import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-admin-create-submission',
  templateUrl: './admin-create-submission.component.html',
  styleUrls: ['./admin-create-submission.component.scss']
})
export class AdminCreateSubmissionComponent { }
